module.exports = __webpack_public_path__ + "img/new_01.cb8b0949.jpg";